module.exports = __webpack_public_path__ + "static/img/zyddyfz.52bd0874.svg";